import { useEffect, useState } from 'react';
import { apiFetch } from '../api/client.ts';
import { useTicketingEmail } from './useTicketingEmail.ts';

interface SystemStatus {
  outboundOk: boolean;
  inboundOk: boolean;
  anyIssue: boolean;
  issues: string[];
}

export function PortalHealthBanner(): React.ReactElement | null {
  const [status, setStatus] = useState<SystemStatus | null>(null);
  const ticketingEmail = useTicketingEmail();

  useEffect(() => {
    apiFetch<SystemStatus>('/api/portal/auth/system-status')
      .then(setStatus)
      .catch(() => undefined);
  }, []);

  if (!status || !status.anyIssue) return null;

  return (
    <div className="mb-4 rounded-[var(--radius-card)] border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
      <div className="font-semibold">Email service degraded</div>
      <p className="mt-1">
        Our portal email service is currently {status.issues.join(' and ')}. Tickets you submit
        here are still received, but email replies may be delayed.{' '}
        <strong>
          If something is urgent, please email{' '}
          <a href={`mailto:${ticketingEmail}`} className="underline">
            {ticketingEmail}
          </a>{' '}
          directly
        </strong>{' '}
        and contact your T3 admin to confirm we've got it.
      </p>
    </div>
  );
}
